import React, { useState, useEffect, useCallback } from 'react';
import { Formik, Form, ErrorMessage } from 'formik';
import { createUseStyles } from 'react-jss';
import { FaTrash } from 'react-icons/fa';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { Helmet } from 'react-helmet';
import LinkButton from '../components/LinkButton';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import DefaultLayout from '../layouts/DefaultLayout';
import Text from '../components/Text';
import FormikTextField from '../components/FormikTextField';
import FormikToggle from '../components/FormikToggle';
import FormikSelect from '../components/FormikSelect';
import FormikTextarea from '../components/FormikTextarea';
import FormikUploadButton from '../components/FormikUploadButton';
import Button from '../components/Button';
import { Category, City, Country } from '../types';
import {
  getAllCategories,
  getAllCities,
  createBusiness,
  getAllCountries,
} from '../services/ApiService';
import Loader from '../components/Loader';
import FormikCheckbox from '../components/FormikCheckbox';
import { RootState } from '../config/store';
import { showRegisterModal } from '../actions/ui';
import FormikErrorMessage from '../components/FormikErrorMessage';
import { push } from 'connected-react-router';
import { setAxiosToken } from '../actions/auth';
import { pageTrack } from '../services/mixpanelService';

export interface BusinessRegisterProps {
  history: any
}

const BusinessRegister: React.FC<BusinessRegisterProps> = ({ history }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [thankMessage, setThankMessage] = useState(false);
  const [categories, setCateogries] = useState<Category[]>([]);
  const [countries, setCountries] = useState<Country[]>([]);
  const [cities, setCities] = useState<City[]>([]);
  const forms = [
    { label: 'Brick-and-Mortar business (Physical shop)', value: 'NORMAL' },
    { label: 'Online eCommerce business', value: 'ONLINE' },
    { label: 'Content Creator', value: 'CONTENT_CREATOR' },
  ];
  const userID = useSelector<RootState, string>((state) => state.auth.user?.id);

  const getKey = function (key: string, url: string = "") {
    if (url == "" && history?.location?.search) {
      url = history.location.search
    }
    if (url.indexOf(key) == -1) {
      return ""
    }
    let keyIndex = url.indexOf(key) + key.length + 1
    url = url.substring(keyIndex)
    let charIndex = url.indexOf("&");
    if (charIndex == -1)
      charIndex = url.length
    let value = url
    if (key == "option") {
      value = url.replace(/%22/g, "\"");
      // } else {
    }
    value = value.substring(0, charIndex)
    return value
  }
  const [token, setToken] = useState<string>(getKey("token"));


  const handleChangeCountry = useCallback((item) => {
    (async () => {
      try {
        const cities = await getAllCities("&country_id=" + item.value);
        setCities(cities);
      } catch (e) {
        console.error(e);
      }
      setLoading(false);
    })();
  }, []
  )
  const categoryPayloadCats = useSelector<RootState, Category[]>((state) => state.categories);
  const countryPayload = useSelector<RootState, Country[]>((state) => state.countries);

  useEffect(() => {
    (async () => {
      try {
        // const countries = await getAllCountries("&limit=10000");
        // const cats = await getAllCategories();
        setCateogries(categoryPayloadCats);
        setCountries(countryPayload)
      } catch (e) {
        console.error(e);
      }
      setLoading(false);
    })();
  }, [categoryPayloadCats,countryPayload]);

  useEffect(() => {
    pageTrack("BUSINESS_REGISTER")
    if (!userID && !token) {
      dispatch(showRegisterModal(false));
    }

    if (token) {
      setAxiosToken(token);
    }
  }, [userID, dispatch]);

  const handleSubmit = useCallback(
    (data, form: any) => {
      if (!userID && !token) {
        dispatch(showRegisterModal());
        return Promise.resolve();
      }
      return (async () => {
        try {
          const formData = new FormData();
          formData.append('user_id', userID);
          Object.keys(data).forEach((key) => {
            if (key === 'city_id' || key === 'type' || key === 'country_id') {
              formData.append(key, data[key].value);
            } else if (key === 'category') {
              data[key].forEach((cat: any) => {
                formData.append('categories[]', cat.value);
              });
            } else if (key === 'is_licensed') {
              formData.append('is_licensed', data[key].value ? 'yes' : 'no');
            } else if (data[key] != null) {
              formData.append(key, data[key]);
            }
          });
          await createBusiness(formData);
          form.resetForm();
          // toast.success('Business has been created successfully');
          // dispatch(push('/'));
          setThankMessage(true)
        } catch (e) {
          form.setSubmitting(false);
          const errors: any = {};
          if (e.response?.data?.error?.details) {
            Object.keys(e.response?.data?.error?.details).forEach((key) => {
              errors[key] = e.response?.data?.error?.details[key];
            });
            form.setErrors(errors);
          }
        }
      })();
    },
    [userID, dispatch],
  );

  return (
    <>
      <DefaultLayout history={history}>
        <Helmet>
          <title>Register your business | twigBIG | Social eCommerce Marketplace in Beauty and Fashion</title>
        </Helmet>
        <Loader center className={classes.loader} loading={loading}>
          {() => (
            <Container fluid className={classes.container}>
              {!thankMessage ?
                <Formik
                  initialValues={{
                    name: '',
                    score: 0,
                    is_licensed: false,
                    legal_name: '',
                    license_image: null,
                    logo: null,
                    manager_name: '',
                    manager_email: '',
                    manager_phone: '',
                    category: [],
                    type: '',
                    country_id: '',
                    city_id: '',
                    address: '',
                    phone: '',
                    website: '',
                    email: '',
                    description: '',
                    terms: false,
                    status: 'Pending',
                  }}
                  // validationSchema={formSchema}
                  onSubmit={handleSubmit}
                >
                  {({
                    handleSubmit: handle,
                    setFieldValue,
                    values,
                    isValid,
                    isSubmitting,
                  }) => (
                    <Form onSubmit={handle}>
                      <Row>
                        <Col xs={12} lg={4}>
                          <Text as="h5" bold>
                            Business Information
                      </Text>
                          <div className={classes.inputBox}>
                            <FormikTextField
                              name="name"
                              placeholder="Business name"
                            />
                            <FormikErrorMessage name="name" />
                          </div>
                          <div className={classes.inputBox}>
                            <label className={classes.flexLabel}>
                              <FormikToggle name="is_licensed" />{' '}
                              <Text className="ml-2 mt-1" as="span" bold>
                                Is it legally incorporated
                          </Text>
                            </label>
                          </div>
                          <div className={classes.inputBox}>
                            <FormikTextField
                              name="legal_name"
                              placeholder="Business legal name"
                            />
                            <FormikErrorMessage name="legal_name" />
                          </div>
                          <div className={classes.inputBox}>
                            <Text as="h5" bold>
                              Select a license file
                        </Text>
                            <div className={classes.uploadContainer}>
                              <FormikUploadButton
                                name="license_image"
                                accept="image/*, application/pdf,.doc,.docx"
                              />
                              {values.license_image ? (
                                <button
                                  onClick={() =>
                                    setFieldValue('license_image', null)
                                  }
                                  className={classes.cancelUploadBtn}
                                >
                                  <FaTrash />
                                </button>
                              ) : null}
                            </div>
                            <FormikErrorMessage name="license_image" />
                          </div>
                          <div className={classes.inputBox}>
                            <FormikTextField
                              name="manager_name"
                              placeholder="Name of the authorized signatory manager"
                            />
                            <FormikErrorMessage name="manager_name" />
                          </div>
                          <div className={classes.inputBox}>
                            <FormikTextField
                              name="manager_email"
                              type="email"
                              placeholder="Manager email"
                            />
                            <FormikErrorMessage name="manager_email" />
                          </div>
                          <div className={classes.inputBox}>
                            <FormikTextField
                              name="manager_phone"
                              placeholder="Manager phone"
                            />
                            <FormikErrorMessage name="manager_phone" />
                          </div>
                        </Col>

                        <Col xs={12} lg={4}>
                          <Text as="h5" color="white" bold>
                            .
                      </Text>
                          <div className={classes.inputBox}>
                            <FormikSelect
                              name="category"
                              placeholder="Select products' categories"
                              options={categories.map((category) => ({
                                label: category.name,
                                value: category.id,
                              }))}
                              isMulti
                            />
                            <FormikErrorMessage name="categories" />
                          </div>
                          <div className={classes.inputBox}>
                            <FormikSelect
                              name="type"
                              placeholder="Select business type"
                              options={forms}
                            />
                            <FormikErrorMessage name="type" />
                          </div>
                          {/* <div className={classes.inputBox}>
                        <FormikSelect
                          name="business_activity"
                          placeholder="Business activity?"
                        />
                      </div> */}
                          {/* <div className={classes.inputBox}>
                          <FormikTextField name="country" placeholder="Country" />
                        </div> */}
                          <div className={classes.inputBox}>
                            <FormikSelect
                              name="country_id"
                              change={handleChangeCountry}
                              placeholder="Country"
                              options={countries.map((country) => ({
                                label: country.long_name,
                                value: country.id,
                              }))}
                            />
                            <FormikErrorMessage name="city_id" />
                          </div>
                          <div className={classes.inputBox}>
                            <FormikSelect
                              name="city_id"
                              placeholder="City"
                              options={cities.map((city) => ({
                                label: city.name,
                                value: city.id,
                              }))}
                            />
                            <FormikErrorMessage name="city_id" />
                          </div>
                          <div className={classes.inputBox}>
                            <Text as="h5" bold>
                              Select a logo
                        </Text>
                            <div className={classes.uploadContainer}>
                              <FormikUploadButton
                                name="logo"
                                accept="image/*"
                              />
                              {values.logo ? (
                                <button
                                  onClick={() =>
                                    setFieldValue('logo', null)
                                  }
                                  className={classes.cancelUploadBtn}
                                >
                                  <FaTrash />
                                </button>
                              ) : null}
                            </div>
                          </div>
                          <div className={classes.inputBox}>
                            <FormikTextarea
                              name="address"
                              placeholder="Pickup address"
                              rows={3}
                            />
                            <FormikErrorMessage name="address" />
                          </div>
                        </Col>

                        <Col xs={12} lg={4}>
                          <Text as="h5" color="white" bold>
                            .
                      </Text>
                          <div className={classes.inputBox}>
                            <FormikTextField
                              name="phone"
                              placeholder="Suppport phone"
                            />
                            <FormikErrorMessage name="phone" />
                          </div>
                          <div className={classes.inputBox}>
                            <FormikTextField
                              name="website"
                              placeholder="Company website"
                            />
                            <FormikErrorMessage name="webiste" />
                          </div>
                          <div className={classes.inputBox}>
                            <FormikTextField
                              name="email"
                              type="email"
                              placeholder="Support email"
                            />
                            <FormikErrorMessage name="email" />
                          </div>
                          <div className={classes.inputBox}>
                            <FormikTextarea
                              name="description"
                              placeholder="Business description (optional)"
                              rows={10}
                            />
                            <FormikErrorMessage name="description" />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                          <div className={classes.termsBox}>
                            <FormikCheckbox
                              id="busiterms"
                              name="terms"
                              checked={values.terms}
                            />
                            <label htmlFor="busiterms">
                              <Text bold as="span">
                                I accept{' '}
                                <a
                                  className={classes.paragraph}
                                  href="https://twigbig.com/info/T_C.html"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Terms
                            </a>{' '}
                            and{' '}
                                <a
                                  className={classes.paragraph}
                                  href="https://twigbig.com/info/Privacy.html"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  Privacy Policy
                            </a>
                              </Text>
                            </label>
                          </div>
                        </Col>
                        <Col>
                          {isSubmitting ? (
                            <Loader center loading />
                          ) : (
                            <Button
                              type="submit"
                              disabled={!isValid || isSubmitting || !values.terms}
                              block
                            >
                              <Text className="m-0" color="white" bold>
                                Submit
                          </Text>
                            </Button>
                          )}
                        </Col>
                      </Row>
                    </Form>
                  )}
                </Formik>
                :
                <div className={classes.thankYouBox}>
                  <Text as="h2" align="center">
                    Seller listing request has been submitted successfully, we will review it and get back to you shortly.              </Text>
                  <Text align="center">
                    For any inquiries, please email us at support@twigbig.com              </Text>
                  <LinkButton to="/" target="_self" isLink={true} >
                    <Text color='white' as="span" bold capitalized>
                      Back to home
                      </Text>
                  </LinkButton>
                </div>
              }
            </Container>
          )}
        </Loader>
      </DefaultLayout>
    </>
  );
};

const useStyles = createUseStyles({
  loader: {
    paddingTop: '50vh',
  },
  container: {
    marginTop: '2rem',
    maxWidth: '85vw',
  },
  inputBox: {
    marginBottom: '2rem',
  },
  flexLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  uploadContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  cancelUploadBtn: {
    border: 'none',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    width: '64px',
    height: '64px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    color: ' #f1f1f1',
    fontSize: '27px',
    marginLeft: '15px',
    '&:focus': {
      outline: 'none',
    },
  },
  paragraph: {
    color: '#9D7CFA !important',
    '&:hover': {
      color: '#9D7CFA',
    },
    '&:visited': {
      color: '#9D7CFA !important',
      textDecoration: 'underline',
    },
  },
  termsBox: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '2rem',
  },
  thankYouBox: {
    textAlign: "center",
    paddingTop: '55px',
    '& > h2': {
      marginBottom: "40px"
    },
    '& > p': {
      marginBottom: "20px !important"
    },
  },

});

export default BusinessRegister;
